/* eslint-disable no-unused-expressions */
import React from 'react';
import { useHistory } from 'react-router';

import { withTranslation } from 'react-i18next';

import { CardMessage } from 'fpay-ui';
import styled from 'styled-components';

import * as ROUTES from '@constants/routes';
import { BANK_ACCOUNT_ERROR } from 'constants/errorType';

const Container = styled.div`
display: flex;
width: 100%
justify-content: center;
margin-top: 48px;
@media (min-width: 768px) {
  margin-top: 96px;
}
`;

const ErrorFundsout = ({ t }) => {
  const history = useHistory();
  const isBankError = history?.location?.state?.errorType === BANK_ACCOUNT_ERROR;

  const handleClick = () => {
    history.push(isBankError ? ROUTES.FUNDS_OUT_EDIT_BANK_ACCOUNT : ROUTES.SELLER_HOME);
  };

  return (
    <>
      <Container>
        <CardMessage
          buttonText={
            isBankError
              ? t('paymentsFoundsOut.detail.errorFundsOutButtonBank')
              : t('paymentsFoundsOut.detail.errorFundsOutButtonGeneric')
          }
          title={t('paymentsFoundsOut.detail.errorFundsOutTitle')}
          subTitle={
            isBankError
              ? t('paymentsFoundsOut.detail.errorFundsOutSubTitleBank')
              : t('paymentsFoundsOut.detail.errorFundsOutSubTitleGeneric')
          }
          handleClick={handleClick}
          htmlIdButton={
            isBankError
              ? 'withdraw-money-funds-out-error-verify-bank'
              : 'withdraw-money-funds-out-error-accept'
          }
          htmlIdErrorAnimation="withdraw-money-funds-out-error"
          type="error"
          isSecundaryButton={isBankError}
          secundaryButtonText={t('paymentsFoundsOut.detail.errorFundsOutButtonLater')}
          handleClickSecundaryButton={() => history.push(ROUTES.SELLER_HOME)}
          htmlIdButtonSecundary="withdraw-money-funds-out-error-later"
        />
      </Container>
    </>
  );
};

export default withTranslation()(ErrorFundsout);
